"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _RatingFeedback = _interopRequireDefault(require("../RatingFeedback"));

var _RatingItem = _interopRequireDefault(require("../../Buttons/RatingItem"));

var _ParagraphText = _interopRequireDefault(require("../../TextElements/BasicTextElements/ParagraphText"));

var _iconNames = _interopRequireDefault(require("../../../constants/iconNames"));

var _Likert = require("./Likert.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Rating component
 */

/* TODO: any fixes here may need to be replicated in NpsScale although there's
 * been enough divergence that that may no longer be the case. Given that
 * NpsScale has been more recently worked on, give solutions there precedence
 * over those in Likert
 */
var Likert = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Likert, _React$PureComponent);

  var _super = _createSuper(Likert);

  function Likert() {
    var _this;

    _classCallCheck(this, Likert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hoverItem: 0
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyUpHandler", function (e) {
      if (e.key === 'Enter') {
        _this.feedbackSubmitHandler();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "feedbackChangeHandler", function (e) {
      return _this.props.feedbackChangeHandler && _this.props.feedbackChangeHandler(e);
    });

    _defineProperty(_assertThisInitialized(_this), "feedbackSubmitHandler", function () {
      return _this.props.feedbackSubmitHandler && _this.props.feedbackSubmitHandler();
    });

    _defineProperty(_assertThisInitialized(_this), "hoverHandler", function (value) {
      _this.setState({
        hoverItem: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "feedbackForm", function () {
      return /*#__PURE__*/_react.default.createElement(_RatingFeedback.default, {
        dataTestId: "likert-rating-feedback",
        feedback: _this.props.feedback,
        feedbackChangeHandler: _this.feedbackChangeHandler,
        feedbackFocus: true,
        feedbackSubmitHandler: _this.feedbackSubmitHandler,
        feedbackCharLimit: _this.props.feedbackCharLimit,
        handleKeyUp: _this.onKeyUpHandler,
        isFeedbackSubmitted: _this.props.isFeedbackSubmitted,
        isRatingSelected: _this.props.isRatingSelected
      });
    });

    _defineProperty(_assertThisInitialized(_this), "ratingClickHandler", function (value) {
      if (!_this.props.isFeedbackSubmitted) {
        return _this.props.ratingClickHandler && _this.props.ratingClickHandler(value);
      }

      return false;
    });

    return _this;
  }

  _createClass(Likert, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          feedbackChangeHandler = _this$props.feedbackChangeHandler,
          feedbackSubmitHandler = _this$props.feedbackSubmitHandler,
          iconName = _this$props.iconName,
          isFeedbackSubmitted = _this$props.isFeedbackSubmitted,
          isRatingSelected = _this$props.isRatingSelected,
          question = _this$props.question,
          rating = _this$props.rating,
          ratingClickHandler = _this$props.ratingClickHandler,
          ratingScale = _this$props.ratingScale,
          props = _objectWithoutProperties(_this$props, ["className", "dataTestId", "feedbackChangeHandler", "feedbackSubmitHandler", "iconName", "isFeedbackSubmitted", "isRatingSelected", "question", "rating", "ratingClickHandler", "ratingScale"]);

      return /*#__PURE__*/_react.default.createElement(_Likert.StyledLikert, _extends({
        className: className,
        "data-test-id": dataTestId
      }, props), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        dataTestId: "likert-question"
      }, /*#__PURE__*/_react.default.createElement("strong", null, question)), /*#__PURE__*/_react.default.createElement("ul", null, _toConsumableArray(Array(parseInt(ratingScale, 10))).map(function (e, i) {
        var k = "rating-".concat(i);
        return /*#__PURE__*/_react.default.createElement(_RatingItem.default, {
          active: rating > i || rating === 0 && _this2.state.hoverItem > i,
          dataTestId: "likert-rating-item",
          hoverHandler: _this2.hoverHandler,
          isFeedbackSubmitted: isFeedbackSubmitted,
          key: k,
          ratingClickHandler: _this2.ratingClickHandler,
          ratingType: iconName,
          value: i + 1
        });
      })), isRatingSelected && this.feedbackForm());
    }
  }]);

  return Likert;
}(_react.default.PureComponent);

_defineProperty(Likert, "propTypes", {
  /** ===================== */

  /** COMPONENT LEVEL PROPS */

  /** ===================== */

  /** Styling hook */
  className: _propTypes.PropTypes.string,

  /** Test ID hook */
  dataTestId: _propTypes.PropTypes.string.isRequired,

  /** Specifies the type of icon to show */
  iconName: _propTypes.PropTypes.oneOf([undefined].concat(_toConsumableArray(_iconNames.default))),

  /** Has the rating been selected? */
  isRatingSelected: _propTypes.PropTypes.bool,

  /** What question are we asking? */
  question: _propTypes.PropTypes.string.isRequired,

  /** ============ */

  /** RATING PROPS */

  /** ============ */

  /** Number value of rating that has been selected */
  rating: _propTypes.PropTypes.number,

  /** onClick function for the rating */
  ratingClickHandler: _propTypes.PropTypes.func.isRequired,

  /** How many stars will there be?  */
  ratingScale: _propTypes.PropTypes.string,

  /** ============== */

  /** FEEDBACK PROPS */

  /** ============== */

  /** Feedback String */
  feedback: _propTypes.PropTypes.string,

  /** onFeedback Input Change */
  feedbackChangeHandler: _propTypes.PropTypes.func.isRequired,

  /** onSubmit function for feedback */
  feedbackSubmitHandler: _propTypes.PropTypes.func.isRequired,

  /** onSubmit function for feedback */
  isFeedbackSubmitted: _propTypes.PropTypes.bool,

  /** Character limit for nps feedback  */
  feedbackCharLimit: _propTypes.PropTypes.number
});

_defineProperty(Likert, "defaultProps", {
  className: '',
  feedback: '',
  iconName: 'star',
  feedbackCharLimit: 255,
  isRatingSelected: false,
  isFeedbackSubmitted: false,
  rating: 0,
  ratingScale: '5'
});

var _default = Likert;
exports.default = _default;